<template>
  <div class="pwc-app-container">
    <div class="pwc-application-form">
      <header class="pwc-question-header">
        <img src="../../assets/logo.png">
      </header>
      <div class="pwc-welcome-content">
        <h2 class="content-title">{{ QuestionFromObjMap.Meta.Title }}</h2>
        <p class="content-disc">{{ QuestionFromObjMap.Meta.Description }}</p>
        <div class="content-btn" @click="goToApply">
          NEXT →
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  QuestionFromObjMap
} from './forminfo/YPApplicationForm'

export default {
  data() {
    return {
      QuestionFromObjMap
    }
  },
  methods: {
    goToApply() {
      this.$router.push({
        path: '/apply',
        query: this.$route.query
      })
    }
  }
}
</script>

<style lang="scss">
  html {
    overflow: hidden;
  }
  .pwc-app-container {
    font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif;
    background-image: url("../../assets/register-form-bg.jpg");
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .pwc-application-form {
      width: 56.25rem;
      height: 37.5rem;
      background-color: rgba(0, 0, 0, 0.3);
      .pwc-question-header {
        display: flex;
        justify-content: center;
        margin-top: 25px;

        img {
          width: 350px;
        }
      }

      .pwc-welcome-content {
        color: #fff;
        .content-title {
          text-align: center;
          line-height: 50px;
          margin: 20px 0 10px 0;
        }
        .content-disc {
          text-align: center;
          padding: 20px;
          line-height: 40px;
          font-size: 18px;
        }
        .content-btn {
          text-align: center;
          line-height: 60px;
          font-size: 20px;
          bottom: 0;
          width: 100%;
          height: 60px;
          background-color: limegreen;
          cursor: pointer;
        }
      }
    }
  }
</style>
